import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

import {
  IoBarChart, IoPeople,
  IoSettings,
} from 'react-icons/io5';
import { PiInvoice, PiPackageFill } from 'react-icons/pi';
import { FaTruckMoving, FaPlaneDeparture, FaUserCircle } from 'react-icons/fa';
import { TbPackages } from 'react-icons/tb';
import { GrSettingsOption, GrUserWorker } from 'react-icons/gr';
import { LuPackageCheck } from 'react-icons/lu';
import { AiOutlineFileUnknown } from 'react-icons/ai';
import { CgLogOut } from 'react-icons/cg';
import { BiSolidReport } from 'react-icons/bi';
import { HiMenuAlt3 } from 'react-icons/hi';
import logo from '../assets/images/freitora_logo-wb.png';

const Sidebar = ({ isOpen = true, onToggle = () => { } }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const user = JSON.parse(localStorage.getItem('user'));
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 799;

  const handleToggle = () => {
    if (typeof onToggle === 'function') {
      onToggle(prev => !prev);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const menuItems = user?.role === 'Courier'
    ? [
      { text: 'Dashboard', route: '/dashboard', icon: <IoBarChart /> },
      { text: 'Packages', route: '/packages', icon: <PiPackageFill /> },
      { text: 'Unknown Packages', route: '/unknown-packages', icon: <AiOutlineFileUnknown /> },
      { text: 'Claims', route: '/claims', icon: <LuPackageCheck /> },
      { text: 'Settings', route: '/settings', icon: <IoSettings /> },
      { text: 'Signout', action: handleLogout, icon: <CgLogOut /> },
    ]
    : [
      { text: 'Dashboard', route: '/dashboard', icon: <IoBarChart /> },
      { text: 'Packages', route: '/packages', icon: <PiPackageFill /> },
      { text: 'Couriers', route: '/couriers', icon: <FaTruckMoving /> },
      { text: 'Shipments', route: '/shipments', icon: <FaPlaneDeparture /> },
      { text: 'Collections', route: '/collections', icon: <TbPackages /> },
      { text: 'Billing', route: '/billing', icon: <PiInvoice /> },
      { text: 'Accounts', route: '/accounts', icon: <IoPeople /> },
      { text: 'User', route: '/user', icon: <FaUserCircle /> },
      { text: 'Staff', route: '/staff', icon: <GrUserWorker /> },
      { text: 'Unknown Packages', route: '/unknown-packages', icon: <AiOutlineFileUnknown /> },
      { text: 'Claims', route: '/claims', icon: <LuPackageCheck /> },
      { text: 'Reports', route: '/reports', icon: <BiSolidReport /> },
      { text: 'Settings', route: '/settings', icon: <GrSettingsOption /> },
      { text: 'Signout', action: handleLogout, icon: <CgLogOut /> },
    ];

  return (
    <>
      {/* Mobile Overlay */}
      {isMobile && isOpen && (
        <div className="fixed inset-0 z-40 bg-black bg-opacity-50" onClick={handleToggle} />
      )}

      {/* Sidebar */}
      <aside
        className={`h-svh ${isMobile ? 'fixed z-50' : 'relative'} ${isOpen ? 'w-64' : 'w-24'
          } bg-[#002e63] text-white transition-all duration-300 flex flex-col`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-4 shrink-0">
          {isOpen ? (
            <img
              src={logo}
              alt="Logo"
              className="w-20 transition-all mx-auto"
            />
          ) : (
            <span className="text-xl font-bold">Freitora</span>
          )}
          <button
            onClick={handleToggle}
            className="text-2xl hover:text-gray-300"
          >
            <HiMenuAlt3 />
          </button>
        </div>

        {/* User Info */}
        {isOpen && user && (
          <div className="px-4 py-2 text-center shrink-0">
            <div className="font-bold">{`${user.first_name} ${user.last_name}`}</div>
            <div className="text-gray-300 text-sm">{user.businessInfo?.business_name ?? ''}</div>
          </div>
        )}

        {/* Navigation Menu */}
        <ul className="flex-1 overflow-y-auto px-2 py-4 space-y-2">
          {menuItems.map(({ text, route, icon, action }, index) => (
            <li key={index}>
              {action ? (
                <button
                  onClick={action}
                  className="flex items-center w-full gap-4 px-4 py-3 rounded-lg transition-all duration-300 hover:bg-blue-800"
                >
                  <span className="text-2xl">{icon}</span>
                  {isOpen && <span className="font-medium">{text}</span>}
                </button>
              ) : (
                <NavLink
                  to={route}
                  className={({ isActive }) =>
                    `flex items-center gap-4 px-4 py-3 rounded-lg transition-all duration-300 ${isActive ? 'bg-blue-600' : 'hover:bg-blue-800'
                    }`
                  }
                >
                  <span className="text-2xl">{icon}</span>
                  {isOpen && <span className="font-medium">{text}</span>}
                </NavLink>
              )}
            </li>
          ))}
        </ul>
      </aside>
    </>
  );
};

export default Sidebar;
